/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { LocalStorageService } from '@hcworkspace/sysque/toolbelt/utils';
import { GlobalConstants } from '../constants/global-constants';
import { FamilyInformationItem } from '../models/family-information-model';
import { SysQueStateService } from '../../../../utils/src/lib/sysque-electrical-state/sysque-elecrical-state.service';
import { AddToSystemReturnCodes } from '../models/add-to-system-return-codes';

export class AddFittingsReceiveController {
  constructor(private localStorageService: LocalStorageService, private sysqueStateService: SysQueStateService) {}

  public AddToSystemResult(response: AddToSystemReturnCodes): void {
    this.localStorageService.updateDispatchLocalStorage(GlobalConstants.ADD_FITTING_INFO, response);
  }

  public CableTrayFamilyInformationResult(response: FamilyInformationItem): void {
    this.localStorageService.updateDispatchLocalStorage(GlobalConstants.FAMILY_INFORMATION_RESPONSE, response);
  }

  public ConduitFamilyInformationResult(response: FamilyInformationItem): void {
    this.localStorageService.updateDispatchLocalStorage(GlobalConstants.FAMILY_INFORMATION_RESPONSE, response);
  }

  public JunctionBoxFamilyInformationResult(response: FamilyInformationItem): void {
    this.localStorageService.updateDispatchLocalStorage(GlobalConstants.FAMILY_INFORMATION_RESPONSE, response);
  }

  public FieldFabFamilyInformationResult(response: FamilyInformationItem): void {
    this.localStorageService.updateDispatchLocalStorage(GlobalConstants.FAMILY_INFORMATION_RESPONSE, response);
  }

  public HandAndMachineBendFamilyInformationResult(response: FamilyInformationItem): void {
    this.localStorageService.updateDispatchLocalStorage(GlobalConstants.FAMILY_INFORMATION_RESPONSE, response);
  }

  public KickHandAndMachineBendFamilyInformationResult(response: FamilyInformationItem): void {
    this.localStorageService.updateDispatchLocalStorage(GlobalConstants.FAMILY_INFORMATION_RESPONSE, response);
  }

  public UserCustomContentFamilyInformationResult(response: FamilyInformationItem): void {
    this.localStorageService.updateDispatchLocalStorage(GlobalConstants.FAMILY_INFORMATION_RESPONSE, response);
  }

  public HangerSpecificationFamilyInformationResult(response: FamilyInformationItem): void {
    this.localStorageService.updateDispatchLocalStorage(GlobalConstants.FAMILY_INFORMATION_RESPONSE, response);
  }

  public RefreshAddFittingDialogData(): void {
    this.localStorageService.updateDispatchLocalStorage(GlobalConstants.REFRESH_ADD_FITTING_DIALOG_DATA, undefined);
  }

  public CloseAction(): void {
    // This method will be used to update the electrical state with the data from the manage mode/add fittings
    // when the window will be closed by clicking on the 'X' button
    this.localStorageService.updateDispatchLocalStorage(
      GlobalConstants.SYSQUE_ELECTRICAL_STATE_KEY,
      this.sysqueStateService.getElectricalState()
    );
  }
}
